import {
  CHECK_APPLICATION_NAME_EXISTS,
  CREATE_BLUECHECK_APPLICATION,
  DELETE_BLUECHECK_APPLICATION,
  GET_ALL_BLUECHECK_APPLICATIONS,
  GET_BLUECHECK_APPLICATION_BY_ID,
  UPDATE_BLUECHECK_APPLICATION,

} from '../constants';
import {
  CreateBlueCheckApplicationRequest,
  BlueCheckApplication,
  BlueCheckApplicationResponse,
  UpdateBlueCheckApplicationRequest,
} from '../types';

export const getAllBlueCheckApplications = async (): Promise<BlueCheckApplication[]> => {
  const storedUser = localStorage.getItem('user');
  const user = JSON.parse(storedUser || '');
  const userInfo = JSON.stringify({
    id: user.providerData[0].uid,
    email: user.providerData[0].email,
    name: user.providerData[0].displayName,
  });
  const response = await fetch(GET_ALL_BLUECHECK_APPLICATIONS, {
    method: 'GET',
    headers: {
      userinfo: userInfo,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch applications.');
  }

  const data = (await response.json()) as { data: BlueCheckApplication[] };
  return data.data;
};

export const createBlueCheckApplication = async (data: CreateBlueCheckApplicationRequest) => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    const user = JSON.parse(storedUser);
    const userInfo = JSON.stringify({
      id: user.providerData[0].uid,
      email: user.providerData[0].email,
      name: user.providerData[0].displayName,
    });
    const response = await fetch(CREATE_BLUECHECK_APPLICATION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'userinfo': userInfo,
      },
      body: JSON.stringify(data),
    });

    return response;
  }
};

export const deleteBlueCheckApplication = async (id: string) => {
  const response = await fetch(DELETE_BLUECHECK_APPLICATION(id), {
    method: 'DELETE',
  });
  if (!response.ok) {
    throw new Error('Failed to delete app');
  }
};

export const updateBlueCheckApplication = async (
  id: string,
  data: UpdateBlueCheckApplicationRequest
) => {
  const response = await fetch(UPDATE_BLUECHECK_APPLICATION(id), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Failed to delete app');
  }
};

export const getApplicationById = async (id: string): Promise<BlueCheckApplication> => {
  const response = await fetch(GET_BLUECHECK_APPLICATION_BY_ID(id), {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch Bluecheck App');
  }

  const data = (await response.json()) as BlueCheckApplicationResponse;

  return data.data;
};

export const checkMetadataNameExists = async (name: string): Promise<boolean> => {
  const response = await fetch(CHECK_APPLICATION_NAME_EXISTS(name), {
    method: 'GET',
  });

  if (!response.ok) {
    console.error('Failed to check metadata name:', response.statusText);
    return true;
  }

  const data = await response.json();
  return data.data.exists;
};
